export default "__VITE_ASSET__Ih_bH61d__ 480w, __VITE_ASSET__BC9MUPDS__ 768w, __VITE_ASSET__Bu9AuVc9__ 1200w, __VITE_ASSET__D68I0X8M__ 1920w";